module.exports = __webpack_public_path__ + "img/roar.c33e3900.jpg";